import {
  Stack,
  StackProps,
  TextField,
  TextFieldProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import { FunctionComponent } from 'react';

export type QuestionProps = {
  containerProps?: StackProps;
  inputProps?: TextFieldProps;
  onChange: (value: any) => void;
  readOnly?: boolean;
  value: any;
  title: React.ReactNode;
  titleProps?: TypographyProps;
};

export const Question: FunctionComponent<QuestionProps> = (props) => {
  const {
    containerProps,
    inputProps,
    onChange,
    readOnly,
    title,
    titleProps,
    value,
  } = props;
  const onChangeValue = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    onChange(event.target.value);
  };
  return (
    <Stack direction="column" spacing={2} {...containerProps}>
      <Typography variant="h4" {...titleProps}>
        {title}
      </Typography>
      <TextField
        {...inputProps}
        onChange={onChangeValue}
        value={value}
        disabled={readOnly}
      />
    </Stack>
  );
};
